import React from 'react';
import { CircularProgress, Backdrop } from '@mui/material';
import { LoadingContainer } from './Loading.styled';

const Loading = ({ open = false }) => {
  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        position: 'fixed',
      }}
    >
      <LoadingContainer>
        <CircularProgress color="primary" />
      </LoadingContainer>
    </Backdrop>
  );
};

export default Loading; 